import { Check, Minus } from "lucide-react";

const ROWS = [
  { type: "Email address", collected: true, shared: false, optional: false, purpose: "Account management" },
  { type: "Name & profile picture", collected: true, shared: false, optional: false, purpose: "Account management, personalization" },
  { type: "Google account ID", collected: true, shared: false, optional: true, purpose: "Account management (Google sign-in only)" },
  { type: "Precise location", collected: false, shared: false, optional: true, purpose: "Processed on-device only; never sent to servers" },
  { type: "Wait-time reports, reviews & ratings", collected: true, shared: false, optional: true, purpose: "App functionality (community wait estimates)" },
  { type: "Favourites, trips, check-ins, alerts", collected: true, shared: false, optional: true, purpose: "App functionality, personalization" },
  { type: "AI triage chat messages (health-related)", collected: true, shared: true, optional: true, purpose: "App functionality — shared with AI provider to generate replies" },
  { type: "Device name & platform", collected: true, shared: false, optional: false, purpose: "Account security (device list, new-device alerts)" },
  { type: "Hashed IP (emergency-term events)", collected: true, shared: false, optional: false, purpose: "Fraud prevention, security, safety auditing" },
  { type: "Contacts, photos, files", collected: false, shared: false, optional: false, purpose: "Not accessed" },
  { type: "Advertising ID", collected: false, shared: false, optional: false, purpose: "Not collected" },
  { type: "Payment info", collected: false, shared: false, optional: false, purpose: "Not collected" },
];

const Mark = ({ on }) => (
  <span
    className={`inline-flex h-6 w-6 items-center justify-center rounded-full ${on ? "bg-[var(--clinical)]/15 text-[var(--clinical)]" : "bg-white/5 text-slate-500"}`}
    aria-label={on ? "Yes" : "No"}
  >
    {on ? <Check size={13} strokeWidth={2.5} /> : <Minus size={13} />}
  </span>
);

export const DataSafetyTable = () => (
  <div data-testid="data-safety-table" className="not-prose my-6 overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]">
    <div className="px-5 py-3 border-b border-white/10 font-display text-sm font-semibold text-white">What we collect at a glance</div>
    <div className="hidden sm:grid grid-cols-[1.4fr_64px_64px_64px_1.6fr] gap-3 px-5 py-3 border-b border-white/10 font-mono text-[10px] uppercase tracking-[0.18em] text-[#b7c2d4]">
      <span>Data type</span>
      <span className="text-center">Stored</span>
      <span className="text-center">Shared</span>
      <span className="text-center">Optional</span>
      <span>Purpose</span>
    </div>
    <ul className="divide-y divide-white/10">
      {ROWS.map((r, i) => (
        <li key={r.type} data-testid={`data-safety-row-${i}`} className="grid grid-cols-1 sm:grid-cols-[1.4fr_64px_64px_64px_1.6fr] gap-2 sm:gap-3 px-5 py-3.5 sm:items-center">
          <span className="text-sm font-medium text-white">{r.type}</span>
          <div className="flex sm:contents gap-4 text-xs text-[#b7c2d4]">
            <span className="flex items-center gap-1.5 sm:justify-center"><Mark on={r.collected} /> <span className="sm:hidden">Stored</span></span>
            <span className="flex items-center gap-1.5 sm:justify-center"><Mark on={r.shared} /> <span className="sm:hidden">Shared</span></span>
            <span className="flex items-center gap-1.5 sm:justify-center"><Mark on={r.optional} /> <span className="sm:hidden">Optional</span></span>
          </div>
          <span className="text-xs sm:text-sm text-[#b7c2d4] leading-snug">{r.purpose}</span>
        </li>
      ))}
    </ul>
    <div className="px-5 py-3 border-t border-white/10 font-mono text-[11px] text-slate-500 leading-relaxed">
      Stored = kept on BeaconShield servers · Shared = sent to a third-party processor · Optional = only if you use the feature. Summary only — the policy text above and below is authoritative.
    </div>
  </div>
);
